import React from 'react'
import ReactDom from 'react-dom'
import GA4Handler from '../ga4_support/GA4Handler'
import App from './App'
import { isLocationAvailable } from '../bridge_interface/bridge_interface'
import { setUpLocationFallback } from './utils'

const hasLocation = isLocationAvailable()

const initWeatherWidget = () => {
  if (hasLocation) {
    const container = document.getElementById('mp_weather_react')
    GA4Handler.impressionHandleEvent(container.parentElement)
    ReactDom.render(<App />, container)
  } else {
    setUpLocationFallback()
  }
}

export default initWeatherWidget
